import { createContext, useEffect, useState } from "react";
import { primaryColor } from "../utils/theme/getPrimaryColor";


const ThemeContext = createContext() 

function ThemeProvider({ children }) {


    const [themeColor, setThemeColor] = useState(primaryColor) // colors will be stored here default is the default color

    useEffect(() => {
        document.documentElement.style.setProperty("--color-primary", themeColor);
        document.documentElement.style.setProperty("--color-primary-light", `${themeColor}36`);
    }, [themeColor]);


    return (
        <ThemeContext.Provider value={{ themeColor, setThemeColor }}>
            {children}
        </ThemeContext.Provider>
    )
}

export { ThemeContext, ThemeProvider }